import Template from '../templates/Template';
import React  from 'react';
import DashboardDemo from '../components/DashboardDemo';
import TemplateGuest from '../templates/TemplateGuest';

import BlocksGuestUserURL from "../components/BlocksGuestUserURL";


const HomeGuest = (props) => {

    console.log("HomeGuest.js");

    const onLoginGuest = (_genericaSistema, idOriginal, genericasSistemaAffect) => {
        console.log("Nuevo login");
    }

    return (
       
        <TemplateGuest>
            <BlocksGuestUserURL />
        </TemplateGuest>

    );

}

export default HomeGuest;
